import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import RenderTable from "components/table";
import { bindActionCreators } from "redux";
import { MenuItemActive } from "store/user-session/user-session-model";
import { Creators as UsersActions } from "store/users/users-duck";
import { IItems } from "store/users/users-model";
import TokenService from "utils/auth/Token.service";
import * as S from "../styled/index.styled";
import ColumnsTable from "./columnsTable";

interface IPropsScreenUsersGrid {
  orderBy?: string;
  ascending?: string;
  itemsByPage?: number;
  pageIndex?: number;
  items?: Array<IItems>;
  totalItems?: number;
  searchFilter?: string;
  editActive?: boolean;
  isLoadingTable: boolean;
}
interface IDispatchProps {
  usersFetchAsync?: (...args) => void;
  usersChangeFieldValue?: (...args) => void;
  usersEditActive?: (...args) => void;
  usersUpdateFormModified?: (...args) => void;
  usersFetchByIdAsync?: (...args) => void;
  usersRolesFetchAsync?: (...args) => void;
  usersClearFilterTable?: (...args) => void;
  locationActiveFetchAsync?: (...args) => void;
  userSessionMenuItemActive?: (...args) => void;
}

type IProps = IPropsScreenUsersGrid & IDispatchProps;

const UsersGrid = ({
  items,
  totalItems,
  searchFilter,
  editActive,
  pageIndex,
  isLoadingTable,
  usersUpdateFormModified,
  usersFetchAsync,
  usersChangeFieldValue,
  usersFetchByIdAsync,
  usersEditActive,
  usersRolesFetchAsync,
  usersClearFilterTable,
  locationActiveFetchAsync,
  userSessionMenuItemActive,
}: IProps) => {
  const tokenService = new TokenService();
  const fetchUsers = useCallback(() => usersFetchAsync(), [usersFetchAsync]);
  const router = useNavigate();

  useEffect(() => {
    userSessionMenuItemActive(MenuItemActive.USERS);
    tokenService.authenticateToken();
  }, []);

  useEffect(() => {
    usersClearFilterTable();
    fetchUsers();
  }, [fetchUsers]);

  useEffect(() => {
    if (searchFilter !== "" || searchFilter === null) {
      usersChangeFieldValue("pageIndex", 1);
      fetchUsers();
    }
  }, [searchFilter]);

  useEffect(() => {
    if (!editActive) {
      usersUpdateFormModified(false);
    }
  }, [editActive]);

  const rolesFetchCallback = useCallback(() => usersRolesFetchAsync(), []);
  const locationActiveFetchCallback = useCallback(() => locationActiveFetchAsync(), []);

  useEffect(() => {
    rolesFetchCallback();
    locationActiveFetchCallback();
  }, []);

  const handleTableChange = (pagination, sorter) => {
    usersChangeFieldValue("orderBy", sorter.field);
    usersChangeFieldValue("ascend", sorter.order);
    usersChangeFieldValue("itemsByPage", pagination.pageSize);
    usersChangeFieldValue("pageIndex", pagination.current);
    fetchUsers();
  };

  const handleClick = (data) => {
    usersFetchByIdAsync(data.id);
    usersEditActive(true);
    router("/private/user/form");
    userSessionMenuItemActive(MenuItemActive.USER_EDIT);
  };

  return (
    <S.UserContainer>
      <RenderTable
        columnsTable={ColumnsTable({ handleClick })}
        items={items}
        totalItems={totalItems}
        handleTableChange={handleTableChange}
        pageIndex={pageIndex}
        isLoadingTable={isLoadingTable}
      />
    </S.UserContainer>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...UsersActions }, dispatch);

const mapStateToProps = (state) => ({
  orderBy: state.Users.orderBy,
  ascending: state.Users.ascending,
  itemsByPage: state.Users.itemsByPage,
  pageIndex: state.Users.filter.pageIndex,
  items: state.Users.items,
  totalItems: state.Users.totalItems,
  searchFilter: state.Users.searchFilter,
  editActive: state.Users.editActive,
  isLoadingTable: state.Users.isLoadingTable,
});

export default connect(mapStateToProps, mapDispatchToActions)(UsersGrid);
